/**
 * Single source of truth for responsive breakpoints.
 * Used by both JS hooks and CSS-in-JSS media queries.
 */
export const BREAKPOINTS = {
    /** Phone portrait / small screens */
    mobile: 600,
    /** Tablet portrait / large phones */
    tablet: 960,
    /** Desktop */
    desktop: 1280,
} as const;

/** Convenience helpers for JSS / CSS media query strings */
export const mediaDown = (px: number) => `@media (max-width:${px}px)`;
export const mediaUp = (px: number) => `@media (min-width:${px}px)`;
